export const Constants = {
    ManageBundleHeading: "Workplace Options Bundle Management",
    ManageBundleDescription:
        "Streamline your pricing workflow with an intuitive, powerful platform for configuring and managing bundle quotes efficiently ",
    ManageBundleBreadcrumb: "Manage Bundles",
    ManageBundles: "Manage Bundles",
    ADDDISCOUNT: "Discount / Rate increase",
    ADDDISCOUNTDESCRIPTION: "Add discount percent to this bundle",
    PLACEHOLDERTEXTDISCOUNTPERCENT: "Discount by percent",
    PLACEHOLDERTEXTDISCOUNTAMOUNT: "Discount by amount",
    PLACEHOLDERTEXTBUNDLENAME: "Bundle name",
    BUTTONDISCOUNTNAMEPERCENT: "Switch to Percent",
    BUTTONDISCOUNTNAMEVALUE: "Switch to Value",
    BUTTONDISCOUNTPREVIEW: "Preview Discount",
    BUTTONAPPROVEBUNDLE: "Approve",
    BUTTONAPPROVEINPROGRESSBUNDLE: "Approving..",
    BUTTONREJECTBUNDLE: "Reject",
    BUTTONNOTIFYBUNDLE: "Notify",
    BUTTONREJECTINPROGRESSBUNDLE: "Rejecting..",
    MESSAGE_BUNDLEREMOVESUCCESS: "Bundle was removed successfully!",
    MESSAGE_BUNDLEADDTOCRMUCCESS: "Bundle was added to CRM successfully!",
    MESSAGE_BUNDLEAPPROVED:
        "Bundle approved! Bundle details will be written to CRM shortly.",
    MESSAGE_SOMETHINGWENTWRONG:
        "Something went wrong! please try again or contact administrator",
    MESSAGE_SOMETHINGWENTWRONG_DUPLICATE:
        "Something went wrong while duplicating quotes, please try again!",
    MESSAGE_SOMETHINGWENTWRONG_GETBUNDLEUPLOADDATA:
        "Something went wrong while fetching bundle data!",
    MESSAGE_SOMETHINGWENTWRONG_ADDBUNDLETOCRM: "Something went wrong while adding bundle to CRM! Please retry or contact administrator",
    MESSAGE_DISCOUNTEMPTY: "Please provide a valid discount value for preview!",
    MESSAGE_BUNDLESUBMITTED: "Bundle submitted succesfully!",
    MESSAGE_BUNDLESUBMITTED_TOPRICINGTEAM:"Bundle submitted for Pricing Team approval!",
    MESSAGE_BUNDLESUBMITTEDERROR:
        "Error occured: Bundle was not submitted. Please try again after sometime!",
    MESSAGE_BUNDLEAPPROVEDERROR:"Error occured: Bundle was not approved. Please try again after sometime!",
    MESSAGE_SAVEUPDATEBUNDLENAMESUCCESS:"Bundle name updated successfully.",
    MESSAGE_SAVEUPDATEBUNDLENAMEERROR:"Something went wrong! Bundle name was not updated.",
    DIALOG_MESSAGE_CONFIRMREMOVEBUNDLE:
        "Are you sure you want to remove the bundle?",
    DIALOG_MESSAGE_PROMPTDUPLICATEBUNDLE:
        "Duplicates will be created for the approved quotes in the bundle to move forward.",
    DIALOG_MESSAGE_NOTEADDSUCCESS: "Bundle note added successfully.",
    DIALOG_MESSAGE_NOTIFYAPPROVERSUCCESS: "Notification sent successfully.",
    DIALOG_MESSAGE_NOTIFYAPPROVERERROR: "Something went wrong while sending the notification.",

    DIALOG_MESSAGE_BUNDLEREJECTSUCCESS: "Bundle rejected.",
    DIALOG_MESSAGE_BUNDLEREJECTERROR: "Something went wrong while rejecting the bundle.",

    DIALOG_MESSAGE_NOTEADDERROR: "Something went wrong while adding the note.",
    TOOLTIP_PROMPTDUPLICATEBUNDLE:"Discount will be applied over Rate(in Requested Currency).",
    CONFIRM: "Confirm",
    SEARCH: "Search Notes",
    OK: "Ok",
    NOTESTITLE: "Notes",
    NOTEBANNER: "Add Note",
    NOTEHEADING: "Note",
    APPROVEBANNER: "Approve",
    APPROVEHEADING: "Please confirm your approval of the quote.",
    NOTIFYBANNER: "Notify",
    NOTIFYHEADING: "This will send a notification to the pending approvers. Do you want to proceed?",
    REJECTBANNER: "Reject",
    REJECTHEADING: "Would you like to reject this quote? Feel free to add a rejection note.",
    VALIDATIONERROR_DISCOUNTINVALIDINPUT: "Please enter a valid number",
    VALIDATIONERROR_DISCOUNTLESSTHANHUNDRED: "Discount cannot be less than -100(%)",
    VALIDATIONERROR_DISCOUNTLESSTHANTOTALAMOUNT: "Discount cannot be less than total amount",
};

export const GridConstants = {
    ACTION: "Action",
    TOTAL_RESULT: "Total Results",
    INITALPAGENO: 1,
    OPP_ID: "Opportunity ID :",
    ACCOUNT_NAME: "Account :",
    OPP_NAME: "Opportunity :",
};

export const BundleNotesHeader = [
    "No.",
    "Created By",
    "Date",
    "Time",
    "Message",
];

export const DialogConstants = {
    CONFIRM: 0,
    APPROVE: 1,
    NOTE: 2,
    REJECT: 3,
};
